import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const productSwiper = () =>{

    var mySwiperThumbs = new Swiper(".c-produts-size__swiper", {
        slidesPerView: 3,
        autoplay: {
            delay: 3000,
        },
        touchMove: true,
        breakpoints:{
            780: {
                slidesPerView: 5,
                spaceBetween: 4,
            },
        }
    });

}


window.addEventListener('load', (event) => {
    
    productSwiper();

});